import withAuthentication from 'utils/withAuthentication'

const IndexPage = () => {
  return 'ola'
}

export default withAuthentication(IndexPage)
